var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3248 10.2739L4.44059 18.158M5.29145 12.4362L1.42965 11.524C1.00478 11.4236 0.855347 10.8961 1.16313 10.5872L4.23428 7.51607C4.44059 7.30976 4.72049 7.19156 5.01378 7.18933L8.47635 7.15922M12.8377 3.19705C15.4149 4.95455 17.6441 7.18375 19.4016 9.76089M10.1614 17.3072L11.0736 21.169C11.1739 21.5939 11.7014 21.7433 12.0103 21.4355L15.0814 18.3644C15.2878 18.158 15.406 17.8781 15.4082 17.5849L15.4383 14.1223M20.0629 7.94875L20.9639 3.61301C21.2093 2.43317 20.1655 1.38938 18.9856 1.63471L14.6499 2.53576C13.373 2.80117 12.2021 3.43347 11.281 4.3557L7.72362 7.91195C6.36647 9.2691 5.48326 11.0288 5.20447 12.9279L5.19221 13.0093C5.01601 14.2215 5.42193 15.4449 6.28729 16.3113C7.15266 17.1767 8.3771 17.5826 9.58928 17.4053L9.67069 17.393C11.5698 17.1154 13.3295 16.231 14.6867 14.8739L18.2429 11.3177C19.1652 10.3965 19.7975 9.22561 20.0629 7.94875Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.e61cc5529eda466a2142c73e6fb6e600.svg";
export { ForwardRef as ReactComponent };